import moment from 'moment-timezone';

import getDeliveryTime from 'local_modules/get_delivery_time';

export default ngInject(function(
  $rootScope,
  $state,
  $stateParams,
  foodhub,
  toaster,
  employeeRoles,
  PurchaseOrder,
  Supplier,
  purchaseOrderFilterService,
  externalUrls,
) {
  this.externalUrls = externalUrls;
  this.foodhub = foodhub;
  this.supplierSlug = $stateParams.supplierSlug;
  this.userCanEdit = employeeRoles.can(
    $rootScope.credentials.google.employee.roles,
    'purchase_orders.edit',
  );
  this.loading = true;

  Supplier.getBySlug($stateParams.supplierSlug)
    .then((vendor) => {
      this.vendor = vendor;
      this.purchaseOrders = purchaseOrderFilterService.query({vendorId: this.vendor.id});
      return this.purchaseOrders.$promise;
    })
    .then(() =>
      this.purchaseOrders.forEach(
        (po) => (po.deliveryTime = getDeliveryTime.start(po, foodhub.tzid)),
      ),
    )
    .finally(() => (this.loading = false));

  this.isPastConfirmDeadline = (purchaseOrder) =>
    ['submitted', 'new'].includes(purchaseOrder.status) &&
    moment(purchaseOrder.confirmBy.toString()).toDate() <= new Date();

  this.isPastDeliveryDeadline = (purchaseOrder) =>
    purchaseOrder.status === 'confirmed' && getDeliveryTime.start(purchaseOrder) <= new Date();

  this.addPurchaseOrder = () => {
    const onSuccess = (purchaseOrder) =>
      $state.go('purchase_orders.show', {poNumber: purchaseOrder.poNumber});

    const purchaseOrder = new PurchaseOrder({
      vendorId: this.vendor.id,
      foodhubSlug: $stateParams.foodhubSlug,
      status: 'new',
      deliverySurcharge: 0,
      dropoffDay: moment
        .tz(foodhub.tzid)
        .add(3, 'days')
        .format('YYYY-MM-DD'),
      dropoffWindow: '6am-8am',
      orderType: 'wholesale',
      confirmBy: moment
        .tz(foodhub.tzid)
        .add(2, 'days')
        .hour(17)
        .toDate(),
      updatedBy: $rootScope.credentials.google.email,
    });
    return purchaseOrder.$save().then(onSuccess, toaster.serverFailCB());
  };

  return this; // http://stackoverflow.com/questions/28953289/using-controller-as-with-the-ui-router-isnt-working-as-expected
});
